import { AnyAction } from 'redux';
import {
  AuthState,
  GET_USER_INFO_SUCCESS,
  LOGOUT_SUCCESS,
  VERIFY_LOGIN_OTP_SUCCESS,
} from '../types/auth';
import jwt_decode from 'jwt-decode';

const initState: Partial<AuthState> = {
  token: null,
};
function authReducer(state = initState, action: AnyAction): Partial<AuthState> {
  switch (action.type) {
    case VERIFY_LOGIN_OTP_SUCCESS: {
      return {
        ...state,
        role: jwt_decode<any>(action?.body?.token)?.role,
        ...action.body,
      };
    }
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        ...action.body,
      };
    }
    case LOGOUT_SUCCESS: {
      return { ...initState };
    }
    default:
      return state;
  }
}

export default authReducer;
